import { useRef, useEffect } from "react";

export const useBarcodeScanner = (onScan, disabled = false) => {
    const buffer = useRef("");
    const timeout = useRef(null);

    useEffect(() => {
        if (disabled) return;

        const handleKeyDown = (e) => {
            if (e.key.length > 1 && e.key !== "Enter") return;

            if (timeout.current) clearTimeout(timeout.current);

            if (e.key === "Enter") {
                if (buffer.current.length >= 3) {
                    onScan(buffer.current);
                }
                buffer.current = "";
                return;
            }

            buffer.current += e.key;

            timeout.current = setTimeout(() => {
                buffer.current = "";
            }, 50);
        };

        window.addEventListener("keydown", handleKeyDown);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [onScan, disabled]);
}